import AddressItem from './styled';

export default AddressItem;
